import React from 'react'
import { CartPlus, HeartIcon } from '../../Images/svgs'

function SideBar() {
    return (
        <>
            <div className="flex flex-col w-[33%] max-md:ml-0 max-md:w-full">
                <div className="flex flex-col max-md:mt-6">
                    <img
                        loading="lazy"
                        srcSet="https://www.riyadhenv.gov.sa/wp-content/uploads/2016/12/DSC_0049.jpg"
                        className="w-full aspect-[1.92] rounded-xl object-cover"
                    />
                    <img
                        loading="lazy"
                        srcSet="https://www.riyadhenv.gov.sa/wp-content/uploads/2016/12/DSC_0049.jpg"
                        className="mt-6 w-full aspect-[1.92] rounded-xl object-cover"
                    />
                    <div className="flex overflow-x-auto flex-col p-5 mt-6 w-full rounded-2xl bg-neutral-50">
                        <div className="self-center text-sm text-center text-blue-900 whitespace-nowrap">
                            تجوز الزكاة
                        </div>
                        <div className="mt-5 text-2xl font-bold text-center whitespace-nowrap text-neutral-900">
                            الإستجابة الطارئة زلزال المغرب
                        </div>
                        <div className="mt-5 text-sm text-center text-zinc-600">
                            بدأت مؤسسة الخير تدخلاً إنسانياً عاجلاً لمساعدة ودعم ضحايا
                            زلزال المغرب، الذي ضرب جنوب غربي مراكش وخلّف مئات الضحايا
                            والإصابات، عدا عن الدمار الهائل.
                        </div>
                        <img
                            loading="lazy"
                            srcSet="https://www.riyadhenv.gov.sa/wp-content/uploads/2016/12/DSC_0049.jpg"
                            className="mt-5 w-full aspect-[1.37] rounded-xl object-cover"
                        />
                        <div className="flex flex-col justify-center items-start pl-16 mt-5 bg-gray-200 rounded max-md:pl-5">
                            <div className="h-2 rounded w-[138px] bg-blue-500" />
                        </div>
                        <div className="self-center mt-5 text-base font-bold text-right whitespace-nowrap text-stone-900">
                            متبقي 66,200$ دولار{" "}
                        </div>
                        <div className="flex gap-2 justify-between mt-3.5">
                            <div className="flex w-full gap-5 justify-between p-1 whitespace-nowrap bg-white rounded-lg border border-solid border-[color:var(--Gray-300,#D0D5DD)]">
                                <input className="my-auto grow w-1/2 text-base leading-6 text-right text-black outline-none indent-1"
                                    placeholder='القيمة'
                                />
                                <button className="justify-center px-3.5 py-2 text-sm font-semibold leading-5 text-white bg-blue-600 rounded-lg border border-blue-500 border-solid shadow-sm aspect-[1.39]">
                                    تبرع
                                </button>
                            </div>
                            <button className="flex justify-center items-center px-3.5 py-3 bg-white rounded-lg border border-solid shadow-sm aspect-[1.11] border-[color:var(--Gray-300,#D0D5DD)]">
                                <CartPlus />
                            </button>
                        </div>
                    </div>
                    <div className="flex flex-col p-2 mt-6 w-full bg-white rounded-lg border border-solid border-zinc-300">
                        <div className="flex overflow-hidden relative flex-col justify-between px-3 pt-3 pb-12 w-full text-sm font-medium tracking-normal leading-3 text-center text-yellow-700 uppercase whitespace-nowrap rounded-md aspect-[1.84]">
                            <img
                                loading="lazy"
                                srcSet="https://www.riyadhenv.gov.sa/wp-content/uploads/2016/12/DSC_0049.jpg"
                                className="object-cover absolute inset-0 size-full"
                            />
                            <div className="flex relative gap-5 justify-between mb-20 max-md:mb-10">
                                <div className="justify-center px-2.5 py-1 my-auto bg-amber-100 rounded-xl border-yellow-700 border-solid aspect-[2.44] border-[0.5px]">
                                    إغاثة
                                </div>
                                <HeartIcon
                                    className="w-6 aspect-square"
                                />
                            </div>
                        </div>
                        <div className="flex flex-col p-2 mt-1">
                            <div className="text-xl font-bold text-right text-zinc-900">
                                عطاؤك مستقبلهم
                                <br />
                            </div>
                            <div className="self-start mt-3 text-sm text-right whitespace-nowrap text-stone-900">
                                آخر تبرع قبل ساعتين
                            </div>
                            <div className="flex flex-col justify-center items-start pl-16 mt-2 bg-gray-200 rounded max-md:pl-5">
                                <div className="h-2 rounded w-[138px] bg-blue-500" />
                            </div>
                            <div className="flex gap-5 justify-between mt-3 text-right text-stone-900">
                                <div className="text-base font-bold">66,200$ دولار </div>
                                <div className="text-sm">$100,000 دولار</div>
                            </div>
                        </div>
                        <div className="flex gap-2 justify-between mt-1">
                            <div className="flex gap-5 justify-between w-full p-1 whitespace-nowrap bg-white rounded-lg border border-solid border-[color:var(--Gray-300,#D0D5DD)]">
                                <input className="my-auto grow text-base leading-6 text-right text-black outline-none w-1/2 indent-1"
                                    placeholder='القيمة'
                                />
                                <button className="justify-center px-3.5 py-2 text-sm font-semibold leading-5 text-white bg-blue-600 rounded-lg border border-blue-500 border-solid shadow-sm aspect-[1.39]">
                                    تبرع
                                </button>
                            </div>
                            <button className="flex justify-center items-center px-3.5 py-3 bg-white rounded-lg border border-solid shadow-sm aspect-[1.11] border-[color:var(--Gray-300,#D0D5DD)]">
                                <CartPlus />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SideBar